export default __webpack_public_path__ + "static/media/empty-side-01.af947fb3.svg";